module.exports = __webpack_public_path__ + "static/media/CormorantInfant-MediumItalic.e24c09ee.ttf";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fonts/CormorantInfant-MediumItalic.ttf
// module id = 3142
// module chunks = 68